import { useSelector } from 'react-redux';
import styles from '../../styles.module.scss';
import cx from 'classnames';
import { AlloyButton } from 'cat-ecommerce-alloy';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useReplaceTokenWithElement } from '@app/hooks';

const EquipmentNoResults = ({ onCheck }) => {
  const [t] = useTranslation();
  const imageUrl = useSelector(
    s => s.myEquipment?.equipments?.selectedEquipment?.imageURL
  );
  const model = useSelector(
    s => s.myEquipment?.equipments?.selectedEquipment?.model
  );

  const serialNumber = useSelector(
    s => s.myEquipment?.equipments?.selectedEquipment?.serialNumber
  );

  const equipmentFamily = useSelector(
    s => s.myEquipment?.equipments?.selectedEquipment?.equipmentFamily
  );
  const { replaceTokenWithElement } = useReplaceTokenWithElement();
  const className = 'text-xl';
  const noMatchingPartsText = replaceTokenWithElement(
    t('MEQ_NO_PARTS_FOUND_SUB_CATEGORY'),
    className,
    <span className="exclude-global text-xl text-univers--bold u-color--DarkGray">
      {model} {equipmentFamily}
    </span>
  );
  return (
    <div className="d-flex flex-column align-items-center justify-content-center mb-4 pb-3 mt-3 mt-md-4 pt-md-3">
      <img
        src={imageUrl}
        alt={`${model} ${serialNumber}`}
        width={'96px'}
        height={'96px'}
        className={cx(styles['equipment_thumbnail'], 'd-lg-block')}
      />
      <p className="text-center text-xl mt-1">{noMatchingPartsText}</p>
      <AlloyButton
        buttonType="secondary"
        size="large"
        className="mt-3"
        onClick={() => onCheck(false)}
      >
        {t('VIEW_ALL_PARTS')}
      </AlloyButton>
    </div>
  );
};

EquipmentNoResults.propTypes = {
  onCheck: PropTypes.func
};

export default EquipmentNoResults;
